module.exports = __webpack_public_path__ + "img/nav-item.510c50b6.png";